import { IFRSListItemDTO } from "../../../api/Quiz/GetAllIFRS";
import IFRSExamRow from "./IFRSExamRow";

interface IFRSExamsTableProps {
  data?: IFRSListItemDTO[];
}

const IFRSExamsTable = ({ data }: IFRSExamsTableProps) => {
  return (
    <div>
      <div className="overflow-x-auto scrollbar-thumb-blue scrollbar-thumb-rounded scrollbar-track-blue-lighter scrollbar-w-2 scrolling-touch">
        <table className="table-auto w-full">
          <thead className="text-lg capitalize">
            <tr className="bg-[#F1F4F9] rounded-t-lg">
              <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                <div className="text-left text-sm">ID</div>
              </th>
              <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                <div className="text-left text-sm">Title</div>
              </th>
              <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                <div className="text-left text-sm">Duration (minutes)</div>
              </th>
              <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                <div className="text-left text-sm">Created At</div>
              </th>
              <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                <div className="text-left text-sm">Actions</div>
              </th>
            </tr>
          </thead>
          <tbody className="text-sm">
            {data && data.length > 0 ? (
              data.map((exam: IFRSListItemDTO) => (
                <IFRSExamRow key={exam.id} exam={exam} />
              ))
            ) : (
              <tr>
                <td
                  colSpan={6}
                  className="px-2 first:pl-5 last:pr-5 py-8 text-center"
                >
                  <div className="text-sm text-gray-500">
                    No IFRS exams found
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default IFRSExamsTable;
